export const paas = [
     {
        "anio" : "2026",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Modificacion al Programa Anual de Adquisiciones",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/MOPAAS2026.pdf"
            },
            {
                "trimestre" : "Programa Anual de Adquisiciones",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/MPAAS2026.pdf"
            },
            {
                "trimestre" : "Primer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/1erinformetrimestralPAAS2026.pdf"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/2doinformetrimestralPAAS2026.pdf"
            }
        ]
    },{
        "anio" : "2025",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Programa Anual de Adquisiciones",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/MPAAS2025.pdf"
            },
            {
                "trimestre" : "Primer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/1erinformetrimestralPAAS2025.pdf"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/2doinformetrimestralPAAS2025.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/3erinformetrimestralPAAS2025.pdf"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/4toinformetrimestralPAAS2025.pdf"
            }
        ]
    },{
        "anio" : "2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Programa Anual de Adquisiciones",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/MPAAS2024.pdf"
            },
            {
                "trimestre" : "Primer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/1erinformetrimestralPAAS2024.pdf"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/2doinformetrimestralPAAS2024.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/3erinformetrimestralPAAS2024.pdf"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/4toinformetrimestralPAAS2024.pdf"
            }
        ]
    },{
        "anio" : "2023",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Modificacion al Programa Anual de Adquisiciones",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/MPAAS2023.pdf"
            },
            {
                "trimestre" : "Programa Anual de Adquisiciones",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PAAS2023.pdf"
            },
            {
                "trimestre" : "Primer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/1erinformetrimestralPAAS2023.pdf"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/2doinformetrimestralPAAS2023.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/3erinformetrimestralPAAS2023.pdf"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/4toinformetrimestralPAAS2023.pdf"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/1erinformetrimestralPAAS2022.pdf"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/2doinformetrimestralPAAS2022.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "whttp://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/3erinformetrimestralPAAS2022.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/4toinformetrimestralPAAS2022.pdf"
            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/1erinformetrimestralPAAS2021.pdf"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/2dotrimestrePAAAS2021.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/3ertrimestrePAAAS2021.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/4totrimestrePAAAS2021.pdf"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PAAS20201.pdf"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PAAS20202.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PAAS20203.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PAAS20204.pdf"
            }
        ]
    }
]